import { apiClient } from "../../../services/axiosInstance";
import { Comic, Artist, Release, Bundle, ServerListResponse } from "../../../types";

export function getComics(queryParams: URLSearchParams, signal?: AbortSignal) {
  return apiClient.get<ServerListResponse<Comic>>(
    `/v1/comics${queryParams.size > 0 ? "?" + queryParams : ""}`,
    { signal },
  );
}
export function getArtists(queryParams: URLSearchParams, signal?: AbortSignal) {
  return apiClient.get<ServerListResponse<Artist>>(
    `/v1/artists${queryParams.size > 0 ? "?" + queryParams : ""}`,
    { signal },
  );
}
export function getReleases(queryParams: URLSearchParams, signal?: AbortSignal) {
  return apiClient.get<ServerListResponse<Release>>(
    `/v1/releases${queryParams.size > 0 ? "?" + queryParams : ""}`,
    { signal },
  );
}
export function getBundles(queryParams: URLSearchParams) {
  return apiClient.get<ServerListResponse<Bundle>>(
    `/v1/bundles${queryParams.size > 0 ? "?" + queryParams : ""}`,
  );
}
export const GET_COMIC_LIST_QUERY_KEY = ["comic-lists"];
export const GET_ARTIST_LIST_QUERY_KEY = ["artist-lists"];
export const GET_RELEASES_LIST_QUERY_KEY = ["releases-lists"];
export const GET_BUNDLES_LIST_QUERY_KEY = ["bundles-lists"];
